import { ProductOption } from './useOtpProducts';
import { Autocomplete, Box, TextField } from '@mui/material';
import { bgColorsVars } from '@design-system/vars.css';
import { Typography } from '@design-system/components/typography/typography';

type SelectProps<T extends { id: number }> = {
  value: T | undefined;
  onChange: (value: T | undefined) => void;
  label?: string;
  error?: string;
  placeholder?: string;
  otps: ProductOption[];
};

export const OTPProductSelect = ({
  otps,
  value,
  error,
  onChange,
}: SelectProps<ProductOption>) => {
  return (
    <div className="flex flex-col w-full">
      <Autocomplete
        options={otps}
        sx={{
          width: '100%',
          '& .MuiInputBase-root': {
            paddingLeft: '12px',
            borderRadius: '10px',
            borderWidth: '2px',
            height: '40px',
            borderColor: error
              ? bgColorsVars['ERROR-100']
              : bgColorsVars['N-40'],
            boxShadow: 'none',
          },
          '& .Mui-focused': {
            borderRadius: '10px',
            borderWidth: '2px',
            height: '40px',
            borderColor: error
              ? bgColorsVars['ERROR-100']
              : bgColorsVars['N-100'],
            boxShadow: 'none',
          },
          '& .MuiInputBase-input': {
            fontSize: '16px',
            fontWeight: 500,
            fontFamily: 'Visuelt',
          },
          '& .MuiInputBase-input::placeholder': {
            color: bgColorsVars['N-100'],
            opacity: 1,
            fontSize: '16px',
            fontWeight: 500,
            fontFamily: 'Visuelt',
          },
        }}
        value={value}
        onChange={(event, value) => onChange(value || undefined)}
        renderInput={(params) => <TextField {...params} placeholder="Select" />}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <Box key={key + option.id} {...optionProps} component="li">
              <div className="w-full flex justify-between items-center">
                <Typography variant="body" size="large">
                  {option.label}
                </Typography>
                {option?.type && (
                  <Typography variant="body" size="small" color="N-60">
                    {option.type}
                  </Typography>
                )}
              </div>
            </Box>
          );
        }}
      />
      {error && (
        <Typography
          variant="body"
          size="small"
          color="ERROR-100"
          className="py-1 px-4"
        >
          {error}
        </Typography>
      )}
    </div>
  );
};
